/**
 * 사용자PC 공지사항 (/u/notice) — DataTables 목록, 제목을 누르면 JBModal 상세
 * ($j.Pages.Desktop.Notice / body data-page-name="Notice")
 */
export default class Notice {
    initialize() {
        $('#noticeTable').DataTable({
            order: [[2, 'desc']],
            pageLength: 20,
            lengthChange: false,
            searching: false,
            columnDefs: [{ targets: 2, type: 'date' }],
            language: {
                info: '총 _TOTAL_ 건 중 _START_ ~ _END_',
                infoEmpty: '데이터 없음',
                infoFiltered: '',
                zeroRecords: '검색 결과가 없습니다.',
                emptyTable: '등록된 공지가 없습니다.',
                paginate: { first: '처음', last: '마지막', next: '다음', previous: '이전' }
            },
            initComplete: function () { $('#noticeBox').css('visibility', 'visible'); }
        });

        // 제목 클릭 → JBModal 상세
        $('#noticeTable').on('click', '.notice-link', function () {
            var num = $(this).data('num');
            var title = $(this).data('title');
            $j.Ui.JBModal.open('jb-notice-detail', '/u/notice/detail?num=' + num, null, {
                title: title,
                width: '640px'
            });
        });
    }
}
